import { useEffect, useRef } from "react";
import apiData from "lib/stores/apiData";
import { ReactComponent as IconLayers } from "components/icons/Layers.svg";
import classNames from "classnames";
import styles from "styles/MapPane.module.scss";
import context from "lib/stores/context";
import { useSnapshot } from "valtio";

let timeout;

const MobileLayersButton = () => {
  const ref = useRef();
  const { showMobileLayersOverlay, isCollapsed } = useSnapshot(context);

  return (
    <button
      onClick={() => (context.showMobileLayersOverlay = true)}
      ref={ref}
      className={classNames(
        "pointer-events-auto px-3 py-1 flex flex-row items-center justify-start space-x-2 space-y-1 border-yellow-400 border-2 bg-white z-[1000] shadow-md",
      )}
    >
      <div>
        <IconLayers />
      </div>
      <span className="text-center text-xs font-bold pb-[5px]">LAYERS</span>
    </button>
  );
};

export default MobileLayersButton;
